import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import './index.css';
import './map/leafletPositionGuards';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Silence console.log/warn/info/debug in production builds.
// console.error is always preserved for debugging critical issues.
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  console.log = noop;
  console.warn = noop;
  console.info = noop;
  console.debug = noop;
}

const root = ReactDOM.createRoot(document.getElementById('root'));

// StrictMode causes Firestore onSnapshot listeners to be created and immediately
// destroyed (double-invocation), triggering a watch-stream race condition in the
// Firebase SDK (assertion ca9 / b815) that permanently breaks the Firestore
// async queue until the page is reloaded.  Controlled via REACT_APP_ENABLE_STRICT_MODE.
const enableStrictMode = process.env.REACT_APP_ENABLE_STRICT_MODE === 'true';
const AppWrapper = enableStrictMode ? React.StrictMode : React.Fragment;

root.render(
  <AppWrapper>
    <Provider store={store}>
      <App />
    </Provider>
  </AppWrapper>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
